import React from 'react';
import {ReportProblem,CancelScheduleSend,LiveHelp } from '@material-ui/icons';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';
import FaceIcon from '@material-ui/icons/Face';
import { AlertStyles } from '../../styles';
import { Avatar,Typography, Box, WithStyles, withStyles} from '@material-ui/core';
import { IGuia, IMensaje } from '../../interface';
import { fechaOrganizada, fechaHora, fechaOrganizadaAlert } from '../../functions/index';
import  imagenRepartidor  from "../../assets/truck.png";
import  imagenAsesor  from "../../assets/face-agent.png";

interface AlertaProp extends WithStyles<typeof AlertStyles> {
    children?: React.ReactNode;
    className?: string;
    tipo:number;
    mensaje?:string;
    guia?:IGuia;
    mensaje_?:IMensaje;
}

const AlertaNovedad = (props:any) : JSX.Element => {
    return (<Box height={10} width="100%">
    <Box className={props.classes.root} >
        <Box display="flex" justifyContent="space-between" m={0.7}>
            <Box display="flex" flexDirection="row" m={0.7}><Box m={0.7}><ReportProblem  color="error" height="25%"/></Box><Box m={0.7} ><Typography>Novedad con direccion destino</Typography></Box> </Box>
            <Typography align="right" component="div" variant="subtitle1"> <Box m={1.5} color="#B4B5B5" fontSize={12} alignContent="flex-end" flexShrink={0}>Abril 15, 2020 a las 3:30 p.m</Box></Typography>
        </Box>
    </Box>
    </Box>
    )
}

const AlertaFinalizado = (props:any) : JSX.Element => {
    return (
        <Box className={props.classes.root} marginTop={1} marginBottom ={1} height={35} width="99.5%">
            <Box>
                 <Box display="flex" flexDirection="row" justifyContent="space-between" m={0.5}>
                         <Box display="flex"><Box  marginTop={1}  marginLeft={1} marginRight={1}><CancelScheduleSend  height="25%"/></Box>
                              <Typography>
                                  <Box width="100%"  marginTop={1.5} fontSize={12}>
                                       <Box>
                                         {props.mensaje_.Mensaje}
                                       </Box>
                                  </Box>
                              </Typography>
                          </Box>
                  <Box>
                 {
                     props.mensaje_.Mobile === true ? ''
                     :
                     <Typography>
                     <Box className={props.classes.box_fecha_web}>                              
                         {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                     </Box>
                     </Typography>
                 }
                  
                 </Box>
              </Box>
              {
                     props.mensaje_.Mobile !== true ? ''
                     :
                     <Typography>
                     <Box display="flex" justifyContent="flex-end" width="95%" fontSize={11}>                              
                         {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                     </Box>
                     </Typography>
                 }
           </Box>
       </Box>
    )
}

const AlertaSoporteAdicional = (props:any) : JSX.Element => {
    return (
      <Box className={props.classes.root} >
          <Box>
               <Box display="flex" flexDirection="row" justifyContent="space-between" m={0.5}>
                       <Box display="flex"><Box color="#FF0000" width={20} height={20}  marginTop={1}  marginLeft={1}  marginRight={1}><LiveHelp color="inherit" fontSize="default"/></Box>
                            <Typography>
                                <Box width="100%"  marginTop={1}  fontSize={12}>
                                     <Box>
                                       {(props.mensaje_.Mensaje).replace("a las","")}
                                     </Box>
                                </Box>
                            </Typography>
                       </Box>
                  <Box>
                  {
                      props.mensaje_.Mobile === true ? ''
                      :
                      <Typography>
                         <Box className={props.classes.box_fecha_web}>                              
                          {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                        </Box>
                       </Typography>
                  }  
                  </Box>
            </Box>
            {
                     props.mensaje_.Mobile !== true ? ''
                     :
                     <Typography>
                     <Box className={props.classes.box_fecha_movil}>                              
                         {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                     </Box>
                     </Typography>
                 }
            
            
         </Box>
     </Box>
    
    )
}

const AlertaInAsesor = (props:any) : JSX.Element => {
    return (
      <Box className={props.classes.root}>
          <Box>
               <Box display="flex" flexDirection="row" justifyContent="space-between" m={0.5}>
                       <Box display="flex"><Box marginTop={1}  width={20} height={20} marginBottom={1.5} marginLeft={1}  marginRight={1}><Avatar style={{width: 27, height: 27}} alt="Remy Sharp" src={imagenAsesor} /></Box>
                            <Typography>
                                <Box width="100%"  marginLeft={1}  marginTop={1.5} marginRight={1} fontSize={12}>
                                     <Box>
                                       {(props.mensaje_.Mensaje).replace("a las","")}
                                     </Box>
                                </Box>
                            </Typography>
                       </Box>
                  <Box>
                  {
                      props.mensaje_.Mobile === true ? ''
                      :
                      <Typography>
                         <Box className={props.classes.box_fecha_web}>                              
                          {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                        </Box>
                       </Typography>
                  }  
                  </Box>
            </Box>
            {
                     props.mensaje_.Mobile !== true ? ''
                     :
                     <Typography>
                     <Box className={props.classes.box_fecha_movil}>                              
                         {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                     </Box>
                     </Typography>
                 }
            
            
         </Box>
     </Box>
    
    )
}

const AlertaInRepartidor = (props:any) : JSX.Element => {
    return (
      <Box className={props.classes.root} >
          <Box>
               <Box display="flex" flexDirection="row" justifyContent="space-between" m={0.5}>
                       <Box display="flex"><Box marginTop={1.5}  width={20} height={20} marginBottom={1.5} marginLeft={1}  marginRight={0.5}><Avatar style={{width: 27, height: 27}} alt="Remy Sharp" src={imagenRepartidor} /></Box>
                            <Typography>
                                <Box width="100%" marginLeft={1}  marginTop={1.5} marginRight={1} fontSize={12}>
                                     <Box>
                                       {(props.mensaje_.Mensaje).replace("a las","")}
                                     </Box>
                                </Box>
                            </Typography>
                       </Box>
                  <Box>
                  {
                      props.mensaje_.Mobile === true ? ''
                      :
                      <Typography>
                         <Box className={props.classes.box_fecha_web}>                              
                          {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                        </Box>
                       </Typography>
                  }  
                  </Box>
            </Box>
            {
                     props.mensaje_.Mobile !== true ? ''
                     :
                     <Typography>
                     <Box className={props.classes.box_fecha_movil}>                              
                         {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                     </Box>
                     </Typography>
                 }
            
            
         </Box>
     </Box>
    
    )
}

const AlertaAsesor = (props:any) : JSX.Element => {
    return (
    <Box marginTop={1} marginBottom={1} width="100%">
        <Box className={props.classes.root} >
            <Box display="flex" justifyContent="space-between" m={0.5}>
                <Box display="flex" flexDirection="row" m={0.5}>
                    <Box color="#FF0202" m='auto'>
                      
                    </Box>
                <Box m={0.5}>
                    <Box fontSize="12px">{props.mensaje}</Box>
                </Box> 
                </Box>
            </Box>
        </Box>
    </Box>
    
    )
}


const Alerta701 = (props:any) : JSX.Element => {
    return (
      <Box className={props.classes.root} >
          <Box>
               <Box display="flex" flexDirection="row" justifyContent="space-between" m={0.5}>
                       <Box display="flex"><Box marginTop={1.5}  width={20} height={20} marginBottom={1.5} marginLeft={1}  marginRight={0.5} color="#FF9300"><ReportProblem color="inherit" height="20%"/></Box>
                            <Typography>
                                <Box width="100%" marginLeft={1}  marginTop={1.5} marginRight={1} fontSize={12}>
                                     <Box>
                                         Novedad en la entrega: Se visita, no se logra entrega
                                     </Box>
                                </Box>
                            </Typography>
                       </Box>
                  <Box>
                  {
                      props.mensaje_.Mobile === true ? ''
                      :
                      <Typography>
                         <Box className={props.classes.box_fecha_web}>                              
                          {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                        </Box>
                       </Typography>
                  }  
                  </Box>
            </Box>
            {
                     props.mensaje_.Mobile !== true ? ''
                     :
                     <Typography>
                     <Box className={props.classes.box_fecha_movil}>                              
                         {fechaOrganizadaAlert(props.mensaje_.Timestamp)}                   
                     </Box>
                     </Typography>
                 }
            
            
         </Box>
     </Box>
    
    )
}


export const AlertaComponent = (props:AlertaProp) : JSX.Element => {
    console.log(props);
    switch (props.tipo) {
        case 1:
            return(<AlertaNovedad classes={props.classes}/>)

        case 2:
            return(<AlertaFinalizado classes={props.classes} mensaje_={props.mensaje_}/>)    

        case 3:
            return(<AlertaSoporteAdicional classes={props.classes} mensaje_={props.mensaje_} guia={props.guia}/>)    

        case 4:
            return(<AlertaAsesor classes={props.classes} mensaje={props.mensaje}/>)   
        
        case 5:
            return(<Alerta701 classes={props.classes} guia={props.guia} mensaje_={props.mensaje_}/>)
            
        case 6:
            return(<AlertaInAsesor classes={props.classes} mensaje_={props.mensaje_} guia={props.guia}/>) 
        
        case 7:
            return(<AlertaInRepartidor classes={props.classes} mensaje_={props.mensaje_} guia={props.guia}/>) 
    
        default:
            return(<></>)    
    }

}
export const Alerta = withStyles(AlertStyles)(AlertaComponent);









/*
<Grid container spacing={3} item xs={12} justify="space-between" direction="row" alignContent="stretch">
    <Grid item xs={12} sm={5} className={styles.padding}>
    
    </Grid>
    <Grid item xs={12} sm={4} justify="flex-end">
        
    </Grid>
    
</Grid>

<Box m={1}><ReportProblem  color="error" />Novedad en en el transporte</Box><Box m={1} ml={1}></Box>
<div className={styles.contenedor}>
    <div>

    <ReportProblem  color="error" />

    </div>

    <div><Typography className={styles.padding}>Novedad entrega en transporte</Typography></div>

    <div>
    <Typography className={styles.padding}>Abril 15, 2020 a las 3:30 p.m</Typography>
      </div>
</div>
*/